import { useI18nContext } from '@/i18n/i18n-react';
import {
  CenteredContent,
  CenteredContentLayout,
} from '@/layouts/centered-content.layout';
import { SidebarLayout } from '@/layouts/sidebar.layout';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import audiencesListImage from '@/assets/feature-preview/audiences/audiences-list.png';
import audienceDetailsImage from '@/assets/feature-preview/audiences/audience-details.png';
import audienceDetailsCustomersImage from '@/assets/feature-preview/audiences/audience-details-customers.png';

export default function AudiencesPreviewPage() {
  const { LL } = useI18nContext();

  const slides = [
    {
      image: audiencesListImage,
      title: LL.audiences.preview.slides.createAudiences.title(),
      description: LL.audiences.preview.slides.createAudiences.description(),
    },
    {
      image: audienceDetailsImage,
      title: LL.audiences.preview.slides.customizeFilters.title(),
      description: LL.audiences.preview.slides.customizeFilters.description(),
    },
    {
      image: audienceDetailsCustomersImage,
      title: LL.audiences.preview.slides.viewCustomers.title(),
      description: LL.audiences.preview.slides.viewCustomers.description(),
    },
  ];

  return (
    <SidebarLayout className="!p-0">
      <CenteredContentLayout>
        <CenteredContent className="pt-32">
          <div className="flex flex-col items-center pb-12">
            <h2 className="text-4xl tracking-tight">
              {LL.audiences.preview.title()}
            </h2>
            <p className="text-center text-muted-foreground text-md max-w-[45ch] mt-2">
              {LL.audiences.preview.description()}
            </p>

            <Carousel className="w-full max-w-[calc(100%-5rem)] mx-auto px-12 mt-8">
              <CarouselContent>
                {slides.map((slide) => (
                  <CarouselItem key={slide.title}>
                    <Card className="w-full overflow-hidden pt-0 border-muted border">
                      <img
                        src={slide.image}
                        alt=""
                        className="w-full object-cover"
                      />
                      <CardHeader>
                        <CardTitle className="text-md font-normal">
                          {slide.title}
                        </CardTitle>
                        <CardDescription className="text-sm font-normal">
                          {slide.description}
                        </CardDescription>
                      </CardHeader>
                    </Card>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
        </CenteredContent>
      </CenteredContentLayout>
    </SidebarLayout>
  );
}
